import { useEffect } from "react";

import { Spinner } from "@/components/shared/spinner";

import { Wrapper } from "./app-loading-component-styles";

export default function AppLoading() {
  useEffect(() => {
    document.body.classList.add("app-loader-visible");

    return () => {
      document.body.classList.remove("app-loader-visible");
    };
  }, []);

  return (
    <Wrapper>
      {/* untranslated label is intentional to prevent hyrdation mismatches */}
      <Spinner size="large" center label="Loading..." />
    </Wrapper>
  );
}
